<template>
  <div class="home-content">
    <div class="head-select" style="display:none;">
      <el-input
        v-model="searchval"
        placeholder="请输入机器名称、编号等"
        class="search-input"
      ></el-input>
      <el-select
        v-model="selectval"
        placeholder="请选择搜索类型"
        class="search-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>      
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
      <el-button type="primary" class="add-button" @click="add">
        新增
      </el-button>
      <el-button type="danger" class="del-button" @click="delMulti">
        删除
      </el-button>
    </div>
    <div class="machine-content">
      <div class="list-con">
        <el-table
          ref="filterTable"
          :data="tabelData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :prop="item.key"
            :label="item.label"
            v-for="item in dataSource1"
            :key="item.key"
          >
            <template slot-scope="scope">
              <div class="text" v-if="slotmap.includes(item.key)">
                {{ scope.row[item.key] }}
              </div>
              <div class="text" v-else-if="item.key == 'threshold'">
                {{ scope.row.department && scope.row.department[item.key] }}
              </div>
              <div v-else-if="item.key == 'menu'" class="tab-menu">
                <div class="edit" @click="binds(scope.row)">修改</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="numdata"
        style="margin-top: 30px; float: right; margin-right: 60px"
        :current-page="current_page"
        :page-size="page_size"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next"
      >
      </el-pagination>       -->
    </div>
    <el-dialog :visible.sync="changevisible"
              :modal-append-to-body="true"
              custom-class="edit-dialog"
              @close="changeclose"
              :destroy-on-close="true" 
              :close-on-click-modal ="false"
              width="720px">
      <div slot="title">工厂编辑</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">工厂名称</div>
          <el-input
            class="edit-input"
            v-model="changedata.name"
            placeholder="请输入工厂名称"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">工厂账号</div>
          <el-input
            class="edit-input"
            v-model="changedata.username"
            placeholder="工厂名称"
            disabled
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">机针预警阈值</div>
          <el-input
            class="edit-input"
            v-model="changedata.threshold"
            placeholder="请输入机针预警阈值"
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="changeclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="changeconfirm"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 客户PC端，工厂管理中需包括工厂名称管理，账号管理，机针预警阀值，密码修改
import { bindScheme,delMachines,editMachines,addMachines,getGrouupLists,getSchemeLists,getadminlist,getdepartEdit,departEdit } from "../../api/index";
export default {
  data() {
    return {
      activeName: "first",
      timer1: "",
      searchval: "",
      selectval:"sn",
      options: [
        { label: "机器编号", value: "sn" },
        { label: "机器名称", value: "name" },
      ],      
      dataSource: [
        { label: "方案名称", key: "name" },
        { label: "是否使用", key: "selected" },
        { label: "操作", key: "menu" },
      ],
      dataSource1: [
        { label: "工厂名称", key: "name" },
        { label: "工厂账号", key: "username" },
        { label: "机针预警阈值", key: "threshold" },
        { label: "操作", key: "menu" }
      ],
      tabelData: [],
      slotmap: ["name", "username","threshold"],
      numdata: 0,
      current_page: 1,
      page_size:10,
      addvisible:false,
      formData:{
        id:0,
        name:"",
        team_id:"",
        sn:"",
        product_id:"",
        remark:"",
      },
      teamList:[],//缝纫机列表
      productList:[],//类型列表
      delList:[],//删除列表
      imgDialogVisible:false,
      imgDialogUrl:"",
      jsonDialog:{},
      imgUrl:"https://fmadmin.sewme.cn",//图片网址
      adminlist: [], // 工厂列表
      changevisible: false,
      changedata: {},
      changeuser: {},
      userid: '',
      username: ''
    };
  },
  methods: {
    //使用方案
    binds(row){
      this.changedata = row
      this.changevisible = true
    },
    delMulti(){
      if(this.delList.length==0){
        this.$message.warning("请选择要删除的缝纫机!");
        return;
      }
      this.$confirm(
        '确认删除选择的缝纫机吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms={
          ids:this.delList,
        }
        delMachines(forms).then(res => {	
          if(res.code==1){
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.delList=[];
            this.getData();
          }else{
            this.$message.warning("删除失败!");
          }					
        });
      }).catch((err) => {
        Message.warning('取消操作');
      }) 
    },
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page=val;
      this.getData();
    },
    getData() {
      let params={};
      if(this.selectval=="sn"){
        params = {
          limit: this.page_size,
          page: this.current_page,
          id: this.userid
          // "search[0][field]": "sn",
          // "search[0][val]": this.searchval,
          // "search[0][operator]": "LIKE",        
        };
      }else{
        params = {
          limit: 10,
          page: this.current_page,  
          // "search[1][field]": "name",
          // "search[1][val]": this.searchval,
          // "search[1][operator]": "LIKE",                
        };
      }
      this.tabelData = []
      getdepartEdit(params)
        .then((res) => {
          if (res.code == 1) {
            const vdata = res.data.row
            vdata.username = this.username
            this.tabelData.push(vdata)
            this.numdata = 1;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page=1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delList=[];
      for(var i=0;i<this.multipleSelection.length;i++){
        this.delList.push(this.multipleSelection[i].id);
      }
      
    },
    add() {
      this.addvisible=true;
    },
    del() {},
    itemdel() {},
    // getadmin() {
    //   getadminlist().then(res => {
    //     this.adminlist = res.data.list
    //     console.log('___getadminlist', this.adminlist)
    //   })
    // }
    changeclose() {
      this.changevisible = false
    },
    changeconfirm() {
      const data = this.changedata
      departEdit(data).then(res => {
        if (res.code == 1) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getData()
          this.changevisible = false
        }
      })
    }
  },
  mounted() {
    var userInfor=localStorage.getItem("userInfor");
    if(userInfor){
      userInfor=JSON.parse(userInfor);
    }
    this.userid = userInfor.department.id
    this.username = userInfor.username
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  height: calc(100% - 64px);
  .statu {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #507af9;
    &.false {
      color: #8e8e8e;
      .small-point {
        background: #8e8e8e;
      }
    }
    .small-point {
      display: inline-flex;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #507af9;
      margin-right: 12px;
    }
  }  
  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;
    .el-date-editor {
      margin-left: 16px;
      width: 185px;
    }
  }
  .search-input {
    width: 245px;
  }
  .search-select {
    width: 185px;
    margin-left: 16px;
  }
  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;
    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }
  .add-button {
    margin-left: auto;
  }
  .del-button {
    margin-right: 125px;
  }
  .machine-content {
    padding: 0 28px;
    height: calc(100% - 88px);
    background: #fff;
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }
  .tab-menu {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }
  .edit {
    cursor: pointer;
    color: #507af9;
  }
  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
</style>
<style lang="scss">
.list-con {
  padding-top: 30px;
  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}
.looks{overflow:hidden;}
.looks .tt{width:90%;margin:0 auto;overflow:hidden;}
.looks .tt img{float:left;height:55px;display:block;margin-top:20px;}
.looks .tt .r_txt{width:80%;float:left;margin-left:20px;}
.looks .tt .r_txt span{color:#2F3338;font-size:24px;display:block;margin:15px 0;margin-top:0px;}
.looks .tt .r_txt label{color:#8F96A0;font-size:24px;display:block;margin:15px 0;}
.looks .cons{overflow:hidden;width:90%;margin:0 auto;background:#F6F7F9;border-radius:5px;margin-top:20px;padding:30px 0;}
.looks .cons .cons_l{float:left;width:50%;overflow:hidden;margin-left:10%;}
.looks .cons .cons_l .single{float:left;width:50%;overflow:hidden;color:#585C61;font-size:18px;line-height:30px;padding:10px 0;}
.looks .cons .cons_r{float:left;width:30%;margin-right:10%;overflow:hidden;}
.looks .cons .cons_r img{width:150px;display:block;border:solid 5px #fff;}
.looks .cons .cons_r span{display:block;width:100%;text-align:center;color:#507AF9;font-size:16px;margin-top:10px;}
.looks .cons .cons_r .img_infor{width:160px;display:block;margin:10px auto;display:flex;flex-wrap:wrap;}
</style>